import React from "react";
import moment from "moment";
import { getRegionBasedDateTime } from "../utils";

/** Display date in grid according to region present in Region column 
 * - If Region is South - Date will be in CST Timezone
 * - If Region is North - Date will be in MST Timezone
 * 
 * By default this component receives UTC date time
*/
export const DateFormatter = (props) => {
  const { value, data } = props
  let dateTime = ''
  
  if (value && data?.Region) {
    dateTime = getRegionBasedDateTime(value, data.Region)
    dateTime = moment(dateTime).format('MM/DD/YYYY')
  }
  
  return <span>{dateTime}</span>
}